export default __webpack_public_path__ + "static/media/numbersinput_standard.ab4726c5.svg";